import React, { useState } from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee"; // ✅ add this line
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowRight,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import Logo from "../../images/newlogo1.jpg";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <>
      {/* Top Bar */}
    <div
  className="text-black text-xs sm:text-sm py-2 px-4 font-semibold bg-gray-100 overflow-x-auto"
  style={{ fontFamily: "Poppins" }}
>
  <Marquee pauseOnHover gradient={false}>
    <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-2 text-center sm:text-left">
      {[
        {
          icon: <FaPhoneAlt size={14} />,
          text: "+91-9845751751 , +91-9606060220",
        },
        {
          icon: <FaEnvelope size={14} />,
          text: "contact@urbannestprop.com | sales@urbannestprop.com",
        },
        {
          icon: <FaMapMarkerAlt size={14} />,
          text:
            "#2nd Floor, No 217, 28th Cross Road, 2nd Block, Rajajinagar, Bengaluru, Karnataka 560010",
        },
      ].map((item, idx) => (
        <span key={idx} className="flex items-center gap-2 whitespace-nowrap">
          {item.icon}
          {item.text}
        </span>
      ))}
    </div>
  </Marquee>
</div>


      {/* Sticky Navbar */}
      <div className="sticky top-0 z-50 bg-[#1a0726] shadow-md">
        <div className="py-3 px-4 flex justify-between items-center">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img src={Logo} alt="KM Infra" title="KM Infra" className="h-16 md:h-20" loading="lazy"/>
          </div>

          {/* Links (Desktop) */}
          <div className="hidden lg:flex space-x-6 xl:space-x-10 font-medium text-amber-100 items-center text-sm xl:text-lg ">
            {["/", "/aboutus", "/ourservices", "/gallery", "/blog", "/contactus"].map((path, idx) => (
              <Link
                key={idx}
                to={path}
                className="hover:text-amber-500 transition-all duration-300"
              >
                {["HOME", "ABOUT US", "OUR SERVICES", "GALLERY", "BLOG", "CONTACT US"][idx]}
              </Link>
            ))}
          </div>

          {/* Enquire (Desktop) */}
          <div className="hidden lg:flex">
            <Link to="/contactus">
              <button className="bg-white text-black px-4 xl:px-6 py-2 rounded-full flex items-center gap-2 hover:bg-blue-700 hover:text-white hover:scale-105 transition-all duration-300 text-sm xl:text-base">
                <FaArrowRight />
                <span>ENQUIRE NOW</span>
              </button>
            </Link>
          </div>

          {/* Mobile Toggle */}
          <div className="lg:hidden text-white">
            <button onClick={toggleMenu} aria-label="Toggle Menu">
              {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="bg-white px-4 py-6 flex flex-col space-y-4 lg:hidden shadow sticky top-0 z-40 ">
          {[
            { label: "HOME", path: "/" },
            { label: "ABOUT US", path: "/aboutus" },
            { label: "OUR SERVICES", path: "/ourservices" },
            { label: "GALLERY", path: "/gallery" },
            { label: "BLOG", path: "/blog" },
            { label: "CONTACT US", path: "/contactus" },
          ].map(({ label, path }) => (
            <Link
              key={label}
              to={path}
              onClick={() => setMenuOpen(false)}
              className="text-black text-lg hover:text-blue-600"
            >
              {label}
            </Link>
          ))}
          <Link to="/contact">
            <button
              onClick={() => setMenuOpen(false)}
              className="bg-blue-700 text-white px-4 py-2 rounded-full flex items-center gap-2 justify-center hover:bg-blue-600 transition"
            >
              <FaArrowRight />
              <span>ENQUIRE NOW</span>
            </button>
          </Link>
        </div>
      )}
    </>
  );
};

export default Navbar;
